<!-- Page banner Area -->
<div class="page-banner bg-8">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content service-banner-content">
                    <h2>Prices</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Prices</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="partner-section container-fluid">

    <!-- HERO -->
    <div class="card border-0 rounded-2 overflow-hidden mb-2 animate-fade-up">
        <div class="card-body p-3 p-md-4 p-lg-5">
            <div class="row g-3 g-lg-4 align-items-center justify-content-center">
                <div class="col-lg-9 text-center px-2">
                    <div class="hero-accent mb-3 mx-auto"></div>

                    <div class="fs-3 text-black fw-semibold">
                        Drop and Ship rates details
                    </div>

                    <h6 class="partner-subheading text-secondary text-center mb-3">
                        At our store, shipping rates are determined by the destination country and
                        are calculated based on the total weight of your order. Rates may vary
                        depending on the country you're shipping to.
                    </h6>

                    <h6 class="partner-subheading text-secondary mb-0">
                        To streamline your Drop and Ship experience, we've categorized the origins
                        of your import boxes into two zones as outlined below:
                    </h6>
                </div>
            </div>
        </div>
    </div>

    <!-- TABS -->
    <div class="card border-0 shadow-sm rounded-4 mb-2 animate-fade-up">
        <div class="card-body p-2">

            <!-- NAV -->
            <ul class="nav nav-pills gap-2 justify-content-center">
                <li class="nav-item">
                    <a class="btn btn-outline-secondary btn-sm px-4" [ngClass]="{'btn-bg' : navOne === 1}"
                        (click)="toggleNavOne(1)">
                        1 Zone
                    </a>
                </li>

                <li class="nav-item">
                    <a class="btn btn-outline-secondary btn-sm px-4" [ngClass]="{'btn-bg' : navOne === 2}"
                        (click)="toggleNavOne(2)">
                        2 Zone
                    </a>
                </li>

                <li class="nav-item">
                    <a class="btn btn-outline-secondary btn-sm px-4" [ngClass]="{'btn-bg' : navOne === 3}"
                        (click)="toggleNavOne(3)">
                        Domestic
                    </a>
                </li>
            </ul>

            <!-- TABLE -->
            <div class="tab-content mt-2">

                <!-- ZONE 1 -->
                <div *ngIf="navOne === 1" class="zone-panel">

                    <div class="card border-0 rounded-4 shadow-sm mb-2">
                        <div class="card-body p-3 p-md-4">
                            <div class="fw-bold mb-2">1 Zone</div>
                            <div class="small">
                                Canada, China, France, Germany, Hong Kong, Italy, Japan, Malaysia,
                                Singapore, South Africa, South Korea, Spain, Thailand, UK and USA.
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-striped table-hover align-middle mb-0 text-md-center">
                            <thead class="table-light">
                                <tr>
                                    <th *ngFor="let header of tableHeaderList" scope="col"
                                        [ngClass]="header.class_names.join(' ')" [style]="headerStyles">
                                        {{ header.column_name }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let country of zone1">
                                    <th>{{ country.country }}</th>
                                    <td>{{ country.exchange_rate_to_usd }}</td>
                                    <td>{{ country.exchange_rate_to_local_currency }}</td>
                                    <td>{{ country.currency_code }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- ZONE 2 -->
                <div *ngIf="navOne === 2" class="zone-panel">
                    <div class="card border-0 rounded-4 shadow-sm mb-2">
                        <div class="card-body p-3 p-md-4">
                            <div class="fw-bold mb-2">2 Zone</div>
                            <div class="small">
                                Egypt, Georgia, India, Jordan, Lebanon, Turkey, and UAE
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-striped table-hover align-middle mb-0 text-md-center">
                            <thead class="table-light">
                                <tr>
                                    <th *ngFor="let header of tableHeaderList" scope="col"
                                        [ngClass]="header.class_names.join(' ')" [style]="headerStyles">
                                        {{ header.column_name }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let country of zone2">
                                    <th>{{ country.country }}</th>
                                    <td>{{ country.exchange_rate_to_usd }}</td>
                                    <td>{{ country.exchange_rate_to_local_currency }}</td>
                                    <td>{{ country.currency_code }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- ZONE 3 -->
                <div *ngIf="navOne === 3" class="zone-panel">
                    <div class="card border-0 rounded-4 shadow-sm mb-2">
                        <div class="card-body p-3 p-md-4">
                            <div class="fw-bold mb-2">Domestic</div>
                            <div class="small">UAE and Saudi Arabia (KSA)</div>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-striped table-hover align-middle mb-0 text-md-center">
                            <thead class="table-light">
                                <tr>
                                    <th *ngFor="let header of tableDomesticHeaderList" scope="col"
                                        [ngClass]="header.class_names.join(' ')" [style]="headerStyles">
                                        {{ header.column_name }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let country of zone3; let i = index">
                                    <th scope="row">{{ country.country }}</th>
                                    <td class="text-md-center" [ngClass]="i===0 ? 'header-text' : ''">{{
                                        country.exchange_rate_to_usd }}</td>
                                    <td class="text-md-center" [ngClass]="i===0 ? 'header-text' : ''">
                                        {{ country.exchange_rate_to_local_currency }}
                                    </td>
                                    <td class="text-md-center">{{ country.currency_code }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- MOROCCO TITLE -->
    <div class="card border-0 shadow-sm rounded-4 mb-4 text-center py-2">
        <h4 class="mb-0">Morocco</h4>
    </div>

    <div class="card border-0 shadow-sm rounded-4 mb-4 animate-fade-up animate-delay-3">
        <div class="card-body p-3 p-lg-4">
            <ul class="nav nav-pills partner-nav gap-2 justify-content-center" id="pills-tab" role="tablist">
                <li class="nav-item partner-nav-item country text-black">
                    <a class="nav-link text-dark btn-hover partner-nav-link btn btn-outline-secondary btn-sm px-4"
                        [ngClass]="{'btn-bg' : navSecond}" (click)="toggleNavSecond(true)" aria-controls="countryzone1"
                        aria-selected="true">
                        <span>1 Zone</span>
                    </a>
                </li>
                <li class="nav-item partner-nav-item country text-black">
                    <a class="nav-link text-dark btn-hover partner-nav-link btn btn-outline-secondary btn-sm px-4"
                        [ngClass]="{'btn-bg' : !navSecond}" (click)="toggleNavSecond(false)"
                        aria-controls="countryzone2" aria-selected="false">
                        <span>2 Zone</span>
                    </a>
                </li>
            </ul>

            <div class="tab-content mt-4" id="pills-tabContent">
                <div *ngIf="navSecond; else zone2Content" id="countryzone1" role="tabpanel"
                    class="zone-panel animate-fade-up">
                    <div class="zone-header country-header card border-0 rounded-4 shadow-sm mb-3">
                        <div class="card-body">
                            <div class="zone-title">1 Zone</div>
                            <div class="zone-zones">
                                USA, UK, UAE, Turkey, China, India, France, Singapore, Canada
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive rounded-4 shadow-sm overflow-hidden">
                        <table class="table table-striped table-hover align-middle zone-table mb-0">
                            <thead class="table-light">
                                <tr>
                                    <th *ngFor="let header of tableHeaderListSecondOne" scope="col"
                                        [ngClass]="header.class_names.join(' ')" [style]="headerStyles">
                                        {{ header.column_name }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row" class="text-md-center">135.00</th>
                                    <td class="text-md-center">75.00</td>
                                    <td class="text-md-center">BHD</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <ng-template #zone2Content>
                    <div id="countryzone2" role="tabpanel" class="zone-panel animate-fade-up">
                        <div class="zone-header country-header card border-0 rounded-4 shadow-sm mb-3">
                            <div class="card-body">
                                <div class="zone-title">2 Zone</div>
                                <div class="zone-zones">Hong Kong, Germany, Italy, Spain</div>
                            </div>
                        </div>
                        <div class="table-responsive rounded-4 shadow-sm overflow-hidden">
                            <table class="table table-striped table-hover align-middle zone-table mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th *ngFor="let header of tableHeaderListSecondOne" scope="col"
                                            [ngClass]="header.class_names.join(' ')" [style]="headerStyles">
                                            {{ header.column_name }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row" class="text-md-center">250.00</th>
                                        <td class="text-md-center">75.00</td>
                                        <td class="text-md-center">BHD</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div class="card border-0 shadow-sm rounded-4 overflow-hidden animate-fade-up animate-delay-4">
        <div class="card-body p-4 p-lg-5">
            <div class="fs-3 text-black fw-semibold text-center">Drop and Ship Rates Details</div>
            <div class="section section-card">
                <h5>1. For Cyprus Destination:</h5>
                <p>Rates from all Drop and Ship Origins (USA, UK, China, Hong Kong, South Africa, Germany, Italy,
                    France, Spain,
                    Singapore, Canada, UAE, Turkey, and India) to Cyprus, will be Euros 13 for the first 0.5 kg and
                    Euros 7 for
                    each additional 0.5 kg.</p>
            </div>
            <div class="section section-card">
                <h5>2. For Iraq Destination:</h5>
                <p>Any shipment to Iraq above 5 kilograms will be charged an additional USD 10 per each 0.5 kilogram.
                </p>
            </div>
            <div class="section section-card">
                <h5>3. For Kazakhstan Destination:</h5>
                <p>For the following cities (Aktau, Aktobe, Astana, Atyrau, Karagandy, Kokshetau, Kostanay, Kyzylorda,
                    Pavlodar,
                    Petropavlovsk, Semei, Shymkent, Taldykorgan, Taraz, Ust-Kamenogorsk, Uralsk) to Kazakhstan, rates
                    from all
                    Drop and Ship origins (US, UK, China, Hong Kong, India, Turkey, UAE, South Africa, Germany, and
                    Italy) will
                    be KZT 3775 for the first 0.5 kg and then KZT 2535 for each additional 0.5 kg.</p>
                <p>Rates for Almaty <b>ONLY</b>, from all Drop and Ship origins (US, UK, China, Hong Kong, India,
                    Turkey, UAE,
                    South
                    Africa, Germany, and Italy) will be KZT 2775 for the first 0.5 kg and then KZT 2053 for each
                    additional 0.5
                    kg.</p>
            </div>
            <div class="section section-card">
                <h5>4. For Malaysia Destination:</h5>
                <p>Rates from Drop and Ship following origins (US, Singapore, India, Turkey, UAE, Hong Kong, and China)
                    to
                    Malaysia, will be MYR 45 for the first 0.5 kg and then MYR 15 for each additional 0.5 kg.</p>
                <p>Rates from other Drop and Ship following origins (Italy, Spain, Germany, France, Canada, UK, and
                    South
                    Africa) to Malaysia, will be MYR 55 for the first 0.5 kg and then MYR 25 for each additional 0.5 kg.
                </p>
                <p>- Domestic service fees when shopping within Malaysia are as below:</p>
                <ul>
                    <li>For West Malaysia: Rates will be MYR 10 for the first 1 kg and then MYR 5 for each additional 1
                        kg.</li>
                    <li>For East Malaysia: Rates will be MYR 15 for the first 1 kg and then MYR 15 for each additional 1
                        kg.
                    </li>
                </ul>
            </div>
            <div class="section section-card mb-0">
                <p>5. Rates above apply for <b>international shipping only</b>; when origin matches destination,
                    domestic
                    shipping
                    charges
                    will apply.</p>
            </div>
        </div>
    </div>
</div>